import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SEGMENTS = [
    {
        key: 'overdue',
        label: 'Overdue',
        fill: 'repeating-linear-gradient(135deg, var(--band-red-mark) 0 3px, var(--band-red) 3px 6px)',
    },
    { key: 'soon', label: 'Due soon', fill: 'var(--band-amber-mark)' },
    { key: 'later', label: 'Later', fill: 'var(--border-control)' },
];
/** The shared scale for a set of sibling bars: the largest total, never below 1. */
export function sharedSegmentMax(rows) {
    return Math.max(1, ...rows.map((r) => r.overdue + r.soon + r.later));
}
/** The exact sentence used as the bar's accessible name. */
export function segmentCountLabel(label, v, max) {
    return `${label}: ${v.overdue} overdue, ${v.soon} due soon, ${v.later} later (scale ${max})`;
}
export function SegmentCount({ overdue, soon, later, max, label, showLegend = true, className, }) {
    const counts = { overdue, soon, later };
    if (typeof max !== 'number' || !Number.isFinite(max) || max <= 0) {
        throw new Error('SegmentCount: `max` (shared scale) is required and must be > 0 (Contract C21)');
    }
    for (const [k, v] of Object.entries(counts)) {
        if (!Number.isInteger(v) || v < 0) {
            throw new Error(`SegmentCount: \`${k}\` must be a non-negative integer (got ${String(v)})`);
        }
    }
    const total = overdue + soon + later;
    if (total > max) {
        throw new Error(`SegmentCount: counts total ${total} exceeds shared max ${max} — derive max from every sibling bar (Contract C21)`);
    }
    return (_jsxs("div", { className: className, "data-segment-count": true, "data-max": max, style: { fontFamily: 'var(--font-sans)' }, children: [_jsx("div", { role: "img", "aria-label": segmentCountLabel(label, counts, max), style: {
                    display: 'flex',
                    gap: '2px',
                    height: '8px',
                    borderRadius: '4px',
                    overflow: 'hidden',
                    background: 'var(--surface-inset)',
                }, children: SEGMENTS.map((s) => {
                    const n = counts[s.key];
                    if (n === 0)
                        return null;
                    return (_jsx("span", { "data-segment": s.key, "data-count": n, style: { display: 'block', height: '100%', width: `${(n / max) * 100}%`, background: s.fill } }, s.key));
                }) }), showLegend ? (_jsx("ul", { "aria-hidden": "true", style: {
                    listStyle: 'none',
                    margin: 'var(--sp-1) 0 0',
                    padding: 0,
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '4px var(--sp-3)',
                    fontSize: 'var(--fs-sm)',
                    color: 'var(--text-muted)',
                }, children: SEGMENTS.map((s) => (_jsxs("li", { "data-segment-label": s.key, style: { display: 'inline-flex', alignItems: 'center', gap: '5px' }, children: [_jsx("span", { style: { width: '10px', height: '10px', borderRadius: '2px', display: 'inline-block', flex: 'none', background: s.fill } }), s.label, " ", _jsx("b", { style: { color: 'var(--text)', fontVariantNumeric: 'tabular-nums' }, children: counts[s.key] })] }, s.key))) })) : null] }));
}
//# sourceMappingURL=SegmentCount.js.map